export const getOrdinal = (n) => {
	var s = ["th", "st", "nd", "rd"],
		v = n % 100;
	return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const getJSON = (url) => {
	return new Promise((resolve, reject) => {
		var request = new XMLHttpRequest();
		request.open("GET", url, true);

		request.onerror = reject;
		request.onload = () => {
			if (request.status >= 200 && request.status < 400) {
				var data = JSON.parse(request.responseText);
				resolve(data);
			} else {
				reject(request.status);
			}
		};

		request.send();
	});
};

export const get = (url) => {
	return new Promise((resolve, reject) => {
		var request = new XMLHttpRequest();
		request.open("GET", url, true);

		request.onerror = reject;
		request.onload = () => {
			if (request.status >= 200 && request.status < 400) {
				resolve(request.responseText);
			}
		};

		request.send();
	});
};

export const numberWithCommas = (x) => {
	if (x === undefined) {
		return "";
	}

	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
